<template>
  <v-container class="pa-0 d-flex flex-column justify-center gap-3">
    <!--  loading --->
    <v-container
      v-if="loading"
      class="d-flex align-center flex-column justify-center text-center fill-height gap-13"
    >
      <!-- <v-sheet
        class="d-flex align-center justify-center mx-auto"
        color="#D9D9D9"
        style="width: 90%; max-width: 400px; aspect-ratio: 1"
      >
      </v-sheet> -->
      <v-progress-circular indeterminate color="primary"></v-progress-circular>

      <v-card-text
        class="ma-0 pa-0 text-body-2 font-weight-medium"
        style="line-height: 1"
      >
        {{ $t("building") }}
      </v-card-text>

      <v-card-text class="ma-0 pa-0 text-body-5 font-weight-bold">
        {{ $t("your business") }}
      </v-card-text>
    </v-container>

    <!--  header --->
    <v-container v-if="!loading" class="pa-0 ma-0 d-flex flex-column align-start gap-13">
      <v-card-title class="pa-0 custom-title">{{ headerTitle }}</v-card-title>
      <v-card-text
        class="pa-0 text-body-2 grey--text text--darken-2"
        v-html="headerSubtitle"
      ></v-card-text>
    </v-container>

    <v-form ref="businessData" class="pa-0 ma-0" v-if="!loading" style="height: 100%">
      <!-- set business data --->
      <v-sheet
        v-if="businessData"
        class="pa-0 d-flex flex-column gap-3 justify-space-between"
        style="height: 100%"
      >
        <v-sheet class="pa-0 ma-0 d-flex flex-column gap-3">
          <!-- business name to hint comment --->
          <v-container class="pa-0 ma-0 d-flex flex-column gap-13">
            <v-text-field
              v-model="name"
              outlined
              clearable
              hide-details="auto"
              :label="$t('business-name')"
              class="rtl-text"
              height="42"
              :rules="[() => !!name || this.$t('is-required')]"
              required
              @blur="handleInputName()"
            >
            </v-text-field>
            <v-select
              v-model="selectedBusinessType"
              :items="businessTypes"
              item-text="name"
              :label="$t('business type')"
              outlined
              hide-details="auto"
              class="rtl-text full-width"
              height="42"
              :rules="[() => !!selectedBusinessType || this.$t('is-required')]"
              required
              return-object
            >
            </v-select>
            <v-card-text class="pa-0 grey--text text--darken-3 text-body-2">
              {{ $t("business type not found help") }}
            </v-card-text>
          </v-container>
          <!-- chechbox to image --->
          <v-container class="pa-0 ma-0 d-flex flex-column gap-13">
            <v-checkbox
              v-model="defualtProductsList"
              :label="$t('smart product suggestion')"
              color="primary"
              class="pa-0 ma-0 checkbox-rtl"
              hide-details
            ></v-checkbox>
            <v-img
              src="@/assets/business/createBusinessImg.png"
              class="ma-0 pa-0 mx-auto"
              style="width: 90%; max-width: 400px; object-fit: contain"
              alt="Business loading image"
            />
          </v-container>
        </v-sheet>

        <!-- confrim btn --->
        <v-container class="pa-0 ma-0">
          <v-btn
            v-if="businessData"
            :loading="loading"
            color="primary"
            large
            block
            depressed
            class="white--text"
            @click="approve"
            >{{ $t("confirm") }}
          </v-btn>
        </v-container>
      </v-sheet>

      <!--set accounting data -->
      <v-sheet
        v-if="accountingData"
        class="pa-0 d-flex flex-column gap-3 justify-space-between"
        style="height: 100%; min-height: 400px"
      >
        <!-- select token to start and end time --->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-13">
          <v-select
            v-model="chooseToken"
            :items="currencies"
            item-text="name"
            outlined
            hide-details="auto"
            :label="$t('select currency')"
            class="rtl-text"
            height="42"
            return-object
          />
          <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 ma-0 text-body-1">
              {{ $t("calendar Type") }}
            </v-card-text>
            <v-btn-toggle v-model="calendarTypeToggle" class="calendar-toggle">
              <v-btn text value="shamsi" class="calendar-btn px-6">
                {{ $t("shamsi") }}
              </v-btn>
              <v-btn text value="gregorian" class="calendar-btn px-6">
                {{ $t("gregorian") }}
              </v-btn>
            </v-btn-toggle>
          </v-container>
          <v-text-field
            v-model="percent"
            :label="$t('default Tax')"
            outlined
            type="number"
            min="0"
            max="100"
            clearable
            hide-details="auto"
            placeholder="10"
            height="42"
            required
          ></v-text-field>
          <v-text-field
            v-model="financialYearName"
            outlined
            clearable
            hide-details="auto"
            :label="$t('financialYear')"
            class="rtl-text"
            height="42"
            :rules="[
              (v) => !!v || this.$t('is-required'),
              (v) => /^[0-9\u06F0-\u06F9]+$/.test(v) || this.$t('only numbers allowed'),
            ]"
            required
            @blur="handleYearName()"
          />
          <!-- date picker & fields --->
          <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
            <template>
              <v-text-field
                id="startDateId"
                v-model="startDate"
                :label="$t('start-date')"
                clear-icon="flaticon2-close-cross"
                outlined
                hide-details="auto"
                class="rtl-text w-100 pl-3"
                height="42"
                dense
                clearable
              />

              <date-picker
                v-model="startDate"
                element="startDateId"
                :locale="currentLocale === 'fa,en' ? 'fa,en' : 'en,fa'"
                :format="currentLocale === 'fa,en' ? 'jYYYY/jMM/jDD' : 'YYYY/MM/DD'"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>

            <template>
              <v-text-field
                id="endDateId"
                v-model="endDate"
                :label="$t('endDate')"
                clear-icon="flaticon2-close-cross"
                hide-details="auto"
                class="rtl-text w-100"
                height="42"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="endDate"
                element="endDateId"
                :locale="currentLocale === 'fa,en' ? 'fa,en' : 'en,fa'"
                :format="currentLocale === 'fa,en' ? 'jYYYY/jMM/jDD' : 'YYYY/MM/DD'"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-container>
        </v-container>

        <!-- confrim btn & return to before step --->
        <v-container class="pa-0 ma-0 d-flex justify-space-between gap-13">
          <v-btn
            v-if="accountingData"
            :loading="loading"
            color="primary"
            depressed
            class="white--text confirm-btn"
            @click="buildBusiness"
          >
            {{ $t("confirm create business") }}
          </v-btn>
          <v-btn
            v-if="accountingData"
            :loading="loading"
            outlined
            class="prev-btn"
            style="border-color: #484848; color: #484848"
            @click="returnTobusinessData"
          >
            {{ $t("previous") }}
          </v-btn>
        </v-container>
      </v-sheet>
    </v-form>

    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment-jalaali";
import General from "@/Mixins/general";

export default {
  name: "BusinessInfoForm",
  mixins: [General],

  data: () => ({
    percent: "10",
    name: "",
    usermobile: "",
    xApikey: null,
    currentLocale: "fa,en",
    startDate: "",
    endDate: "",
    financialYearName: "",
    chooseToken: null,
    selectedBusinessType: null,
    businessTypesLoaded: false,
    startMenu: false,
    defualtProductsList: false,
    endMenu: false,
    businessData: true,
    accountingData: false,
    loading: false,
    EmitOnce: false,
    removed: false,
    snakbar: false,
    snakbarColor: null,
    snakbarText: null,
    valueFlags: {
      nameValue: false,
      typeValue: false,
    },
    businessTypes: [],
    currencies: [],
  }),
  created() {
    this.getCurrency();
    this.getBusinessType();
  },
  computed: {
    calendarTypeToggle: {
      get() {
        if (this.currentLocale === "fa,en") {
          return "shamsi";
        }
        return "gregorian";
      },
      set(newValue) {
        if (newValue === "shamsi") {
          this.currentLocale = "fa,en";
        } else if (newValue === "gregorian") {
          this.currentLocale = "en,fa";
        }
      },
    },
    headerTitle() {
      if (this.businessData) return this.$t("business info");
      if (this.accountingData) return this.$t("accounting information");
      return "";
    },
    headerSubtitle() {
      if (this.businessData) return this.$t("enter business information");
      if (this.accountingData) return this.$t("choose accounting information");
      return "";
    },
  },
  mounted() {
    if (this.currentLocale === "fa,en") {
      this.startDate = moment().format("jYYYY/jMM/jDD");
      this.endDate = moment().endOf("jYear").format("jYYYY/jMM/jDD");
    } else {
      this.startDate = moment().format("YYYY/MM/DD");
      this.endDate = moment().endOf("year").format("YYYY/MM/DD");
    }
    this.usermobile = localStorage.getItem("usermobile") || "";
    this.xApikey = JSON.parse(localStorage.getItem("primaryToken"));
    this.financialYearName = this.$store.state.year
      ? String(this.$store.state.year)
      : this.currentLocale === "fa,en"
      ? moment().format("jYYYY")
      : moment().format("YYYY");
  },
  watch: {
    currentLocale(newVal) {
      if (newVal === "fa,en") {
        //shamsi
        this.startDate = moment().format("jYYYY/jMM/jDD");
        this.endDate = moment().endOf("jYear").format("jYYYY/jMM/jDD");
      } else {
        //gregorian
        this.startDate = moment().format("YYYY/MM/DD");
        this.endDate = moment().endOf("year").format("YYYY/MM/DD");
      }
    },
    selectedBusinessType(newValue, oldValue) {
      if (!oldValue && newValue) {
        let Type = this.selectedBusinessType;
        if (Type != null && Type != undefined && Type != "") {
          this.$emit("hasType-value", {
            flag: true,
            number: 1,
          });
        }
      }
      if (oldValue && oldValue != "") {
        this.$emit("hasType-value", {
          flag: false,
          number: 1,
        });
        if (newValue) {
          this.$emit("hasType-value", {
            flag: true,
            number: 1,
          });
        }
      }
    },
    businessData(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        let defaultYearName = this.financialYearName?.trim();
        let defaultStartDate = this.startDate?.trim();
        let defaultEndDate = this.endDate?.trim();
        if (!this.EmitOnce) {
          if (defaultYearName && defaultYearName != "" && defaultYearName !== null) {
            this.EmitOnce = true;
            this.$emit("hasFinancialYear-value", {
              flag: true,
              number: 2,
            });
          }
          if (
            defaultStartDate != "" &&
            defaultStartDate !== null &&
            defaultEndDate != "" &&
            defaultEndDate !== null
          ) {
            this.$emit("hasFinancialYear-value", {
              flag: true,
              number: 2,
            });
          }
        }
      }
    },
    financialYearName(newVal) {
      if (!this.removed) {
        if (newVal == null || newVal?.trim() == "") {
          this.$emit("hasFinancialYear-value", { flag: false, number: 2 });
          this.removed = true;
        }
      }
    },
  },
  methods: {
    approve() {
      const form = this.$refs.businessData;
      if (!form.validate()) {
        return;
      }
      this.businessData = false;
      this.accountingData = true;
      this.$emit("next-step", {
        flag: true,
        number: 1,
      });
    },
    getBusinessType() {
      var app = this;
      if (app.businessTypesLoaded) return;
      app.businessTypesLoaded = true;
      this.$axios
        .get(this.$apipoint + "v2/business-category", {
          headers: {
            Authorization: "",
            domain: "",
          },
        })
        .then((response) => {
          app.businessTypes = response.data.data.reverse();
        })
        .catch((err) => {
          app.businessTypesLoaded = false;
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
          app.overlay = false;
        });
    },
    getCurrency() {
      var app = this;
      this.$axios
        .get(this.$apipoint + "getcurrency?select=aiCurrency", {
          headers: {
            Authorization: "",
            domain: "",
          },
        })
        .then((response) => {
          app.currencies = response.data.data;
          app.chooseToken = this.currencies.find((t) => t.id == 1);
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
          app.loading = false;
        })
        .finally(() => {
          app.overlay = false;
          app.loading = false;
        });
    },
    buildBusiness() {
      const additional_data = JSON.parse(localStorage.getItem("additional_data"));
      var app = this;
      app.loading = true;
      const lang = app.$root.$i18n.locale;
      this.$axios
        .post(
          this.$apipoint + "v2/register/customer",
          {
            lang: lang,
            tax: this.percent,
            mobile: this.usermobile,
            abrName: this.name,
            yearName: this.financialYearName,
            from: this.startDate,
            to: this.endDate,
            business_id: this.selectedBusinessType.id,
            add_business_template: this.defualtProductsList,
            currency: this.chooseToken,
            dateFormat: this.currentLocale,
            additional_data: additional_data,
          },
          {
            headers: {
              x_api_key: this.xApikey,
            },
          }
        )
        .then((response) => {
          this.accountingData = false;

          // set token localStorage and header
          localStorage.setItem("fullname", response.data.username);
          localStorage.setItem("token", JSON.stringify(response.data.meta));
          app.$axios.defaults.headers.common.Authorization =
            "Bearer " + response.data.token;

          // set APP_KEY localStorage and header
          localStorage.setItem("APP_KEY", response.data.meta.init.abrKey);
          app.$axios.defaults.headers.common.domain = response.data.meta.init.abrKey;

          delete app.$axios.defaults.headers.common.x_api_key;
          delete app.$axios.defaults.headers.common.domain;

          app.$store.commit("SET_FULLNAME", response.data?.username);
          app.$store.commit(
            "SET_CURRENCY_SYMBOL",
            response.data.meta.init.currencySymbol
          );
          app.$store.commit("SET_FINANCIALYEAR", response.data.meta.init.financialYear);

          app.$store.commit(
            "SET_BACKGROUNDIMAGE",
            response.data.meta.init.backgroundImage
          );
          app.$store.commit(
            "SET_BACKGROUNDCOLOR",
            response.data.meta.init.backgroundColor
          );

          app.$store.commit("SET_START_DATE", response.data.meta.init.startDate);
          app.$store.commit("SET_END_DATE", response.data.meta.init.endDate);
          app.$store.commit("SET_THEME_COLOR", response.data.meta.init.theme_color.value);
          app.$store.commit("SET_DARK", response.data.meta.init.dark.value);
          app.$store.commit("SET_HOVERMENU", response.data.meta.init.hoverMenu.value);
          app.$store.commit(
            "SET_APPBARSOPACITY",
            response.data.meta.init.appBarsOpacity.value
          );

          app.$store.commit("SET_ACCESS", response.data.meta.init.access);
          app.$store.commit("SET_LANG", response.data.meta.init.lang.value);
          app.$store.commit("SET_RTL", response.data.meta.init.rtl.value);
          app.$store.commit("SET_DATE_LOCALE", response.data.meta.init.date_locale.value);
          app.$store.commit(
            "SET_NEGATIVE_INVENTORY",
            response.data.meta.init.negative_inventory.value
          );

          app.$store.commit("SET_CURRENCY", response.data.meta.init.currency);
          app.$store.commit("SET_MENU_BOOKMARK", response.data.meta.init.menuBookmark);
          app.$store.commit("SET_PERMISSIONS", response.data.meta.init.permissions);
          if (response.data.meta.init.teacherAccess) {
            app.$store.commit("SET_TEACHERACCESS", "active");
            app.$router.push({ name: "academyDashboard" });
          }
          if (app.shopProp) {
            app.$router.push({ path: "shop/initialize" });
          }
          localStorage.setItem("apn", null);
          app.$router.push("/");
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
          app.overlay = false;
        });
    },
    returnTobusinessData() {
      this.businessData = true;
      this.accountingData = false;
      this.$emit("previous-step", {
        flag: false,
        number: 1,
      });
    },
    handleInputName() {
      let Name = this.name?.trim();
      if (Name != null && Name != undefined && Name != "") {
        this.$emit("hasName-value", {
          flag: true,
          number: 1,
        });
      } else if (Name == null || Name == "" || Name == undefined) {
        this.$emit("hasName-value", {
          flag: false,
          number: 1,
        });
      }
    },
    handleYearName() {
      let yearName = this.financialYearName?.trim();
      if (
        yearName !== null &&
        yearName !== undefined &&
        yearName !== "" &&
        !isNaN(Number(yearName))
      ) {
        this.$emit("hasFinancialYear-value", {
          flag: true,
          number: 2,
        });
        this.removed = false;
      }
    },
  },
};
</script>

<style scoped>
.v-text-field--enclosed .v-input__append-inner {
  margin-top: 10px;
}
::v-deep(input[type="number"]::-webkit-inner-spin-button),
::v-deep(input[type="number"]::-webkit-outer-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}
::v-deep(input[type="number"]) {
  -moz-appearance: textfield;
}
:deep(.v-input--selection-controls .v-input__slot > .v-label) {
  color: #424242 !important;
  margin-top: 0;
  padding: 0;
}
:deep(.v-responsive__content) {
  width: auto !important;
  height: auto !important;
}
::v-deep .v-label {
  top: 10px !important;
}
::v-deep .v-label.v-label--active {
  top: 18px !important;
}
.checkbox-rtl :deep(.v-selection-control) {
  flex-direction: row-reverse !important;
}
.checkbox-rtl :deep(.v-selection-control__input) {
  order: 2;
}
.checkbox-rtl :deep(.v-label) {
  order: 1;
  text-align: right;
}
.loading-message {
  min-height: 100%;
  font-weight: 600;
  font-style: normal;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  margin-top: 0.9rem;
}
.calendar-toggle {
  border-radius: 4px;
  border: #858383 solid 0.8px;
  color: #808080;
}
.calendar-btn {
  color: #808080 !important;
  border: none !important;
}
.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
  padding: 20px 28px !important;
}
.v-btn-toggle .v-btn.v-item--active.calendar-btn {
  border: 1px solid #0066ff !important;
  color: #0066ff !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}
.confirm-btn {
  flex: 0 0 60%;
}
.prev-btn {
  flex: 0 0 25%;
}
.v-text-field__details {
  margin: 0px;
  display: flex;
  flex: 1 0 auto;
  max-width: 100%;
  max-height: 2px;
  overflow: hidden;
}
@media (max-width: 580px) {
  .calendar-toggle {
    font-size: 12px !important;
  }
  .calendar-toggle {
    font-size: 12px !important;
  }
}
::v-deep .vpd-locales {
  display: none;
}
@media (max-width: 758px) {
  .v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding: 20px 16px !important;
  }
}
</style>
